import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";

const Home = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // Get the element's top relative to the document
      const navBarHeight = 80; // Adjust this if your navbar height changes
      const y =
        element.getBoundingClientRect().top + window.pageYOffset - navBarHeight;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div name="home" className="w-full h-screen bg-[#0a192f]" id="home">
      <div className="max-w-screen-lg mx-auto flex flex-col justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          {/* Intro Text */}
          <p className="text-sm text-pink-600 uppercase tracking-widest">
            Hi, my name is
          </p>
          <h1 className="text-4xl sm:text-7xl font-bold text-white">
            Asantae Shelton
          </h1>
          <h2 className="text-5xl sm:text-7xl text-[rgba(255,255,255,0.7)]">
            Software Engineer
          </h2>

          {/* Professional Summary */}
          <p className="text-gray-500 py-4 max-w-xlg">
          I design and develop scalable, user-centric software solutions that enhance business performance and deliver seamless digital experiences. 
          With expertise in full-stack development, I leverage modern technologies like React, Node.js, and C# to build efficient, intuitive platforms that empower users and drive growth.
          </p>

          {/* View Work and Download Resume Buttons */}
          <div className="flex flex-direction-row flex-wrap">
            <div className="mr-3">
              <Link
                onClick={() => scrollToSection("portfolio")}
                className="group text-white w-fit px-5 py-2 my-1 flex items-center border border-white cursor-pointer"
              >
                View Work
                <span className="group-hover:rotate-90 duration-300">
                  <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                </span>
              </Link>
            </div>
            <div>
              <a
                href="/Asantae_Shelton_Resume.pdf"
                download="Asantae_Shelton_Resume.pdf"
                className="group text-white w-fit px-5 py-2 my-1 flex items-center border border-white cursor-pointer"
              >
                Download Resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;